import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import _get from 'lodash.get';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import SixColumnLayout from 'components_v2/desktop/SixColumnLayoutV2';
import Heading from 'routes/affiliates/components/atoms/Heading/Heading';
import { TOI_LIVE_DOMAIN, TOI_DEV_DOMAIN } from 'constants/index';
import s from './AffiliateStories.scss';

const AffiliateStories = props => {
  const { data, dataURL } = props;
  const [finalData, setFinalData] = useState(data);
  useEffect(() => {
    if (!finalData && dataURL) {
      const Domain = __PROD__ ? TOI_LIVE_DOMAIN : TOI_DEV_DOMAIN;
      makeRequest
        .get(`${Domain}${dataURL}`)
        .then(json => {
          if (json.status === 200 && json.data) {
            setFinalData(json.data);
          }
        })
        .catch(err => console.log(err));
    }
  }, []);

  if (!finalData) {
    return null;
  }

  const sectionData = {
    id: finalData.type,
    items: finalData.items,
    gaAction: _get(finalData, 'config.ga.action'),
    target: _get(finalData, 'config.target'),
    ga4Type: finalData?.ga4Type,
  };

  const headingSize = _get(finalData, 'config.headingSize');
  const placedInsideWidget = _get(finalData, 'config.insideWidget');
  return (
    <div className={`${s.container} ${!placedInsideWidget ? s.adjust : ''}`}>
      <Heading
        url={_get(finalData, 'config.linkout')}
        text={_get(finalData, 'config.headingText')}
        className={headingSize === 'small' ? s.heading : s.headingLarge}
        ga={{
          category: _get(finalData, 'config.ga.category'),
          action: `${sectionData.gaAction}_click`,
        }}
        urlTarget={_get(finalData, 'config.target')}
      />
      <SixColumnLayout
        key={finalData.type}
        sectionData={sectionData}
        wrapperClass={s.stories}
      />
      <InterSectionBorder />
    </div>
  );
};

AffiliateStories.propTypes = {
  data: PropTypes.shape({}),
  dataURL: PropTypes.string,
};

AffiliateStories.defaultProps = {
  data: null,
  dataURL: '',
};

export default AffiliateStories;
